import React, { Component, Fragment } from 'react';
import Grid from '../../../Utils/Grid/index';
import { TableHeaderColumn } from "react-bootstrap-table";
import {RenderMoneda} from "../../../Utils/renderField/renderTableField";
import { RenderDateTime } from "../../../Utils/renderField/renderReadField";


export default class GridPrecioProducto extends Component {

    render() {
        const { loader, data, page, listar, onPageChange, onSortChange} = this.props;
        return (
            <Fragment>
                <Grid
                    hover
                    striped
                    data={data}
                    loading={loader}
                    page={page}
                    className="reporte-table"
                    onPageChange={listar} onSortChange={onSortChange}
                >
                    <TableHeaderColumn
                        isKey
                        dataField="id"
                        dataSort
                        className='reporte-table'
                        dataFormat={(cell)=>(
                                cell ? '' : ''
                            )
                        }
                        width="10%"
                    />
                    <TableHeaderColumn
                        dataField="fecha"
                        dataSort
                        className='reporte-table'
                        dataFormat={(cell, row) => (
                            cell ? <RenderDateTime value={cell} /> : "Sin registro"
                        )}
                    >
                        FECHA
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="cliente"
                        dataSort
                        className='reporte-table'
                        dataFormat={(cell, row) => (
                            cell ? cell : "Sin registro"
                        )}
                    >
                        CLIENTE
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="precio_unitario"
                        dataSort
                        className='reporte-table'
                        dataAlign="right"
                        tdStyle={{paddingRight: "5%"}}
                        thStyle={{paddingRight: "5%"}}
                        dataFormat={(cell) => ( cell  || cell == 0 ? <RenderMoneda monto={cell}/> : "Sin registro" )}
                    >
                        PRECIO
                    </TableHeaderColumn>
                </Grid>
            </Fragment>
        )
    }

}
